import { useState } from "react";
import Link from "next/link";
import { useRouter } from 'next/router';
import { Form, Col, Button, InputGroup, FormControl } from 'react-bootstrap';
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from 'react-toastify';
import { authServices } from "@/services/authServices";

function ResetPasswordCard(props) {
    const { pageStateHandler, userType } = props;
    const [password, setPassword] = useState({ type: 'password', icon: 'fa-eye-slash' });
    const [confirmPassword, setConfirmPassword] = useState({
        type: "password",
        icon: "fa-eye-slash",
      });
    const [validationErrors, setValidationErrors] = useState([]);
    const { query, push } = useRouter();

    const handleClickShowPassword = () => {
        password.type === 'password'
            ? setPassword({ ...password, type: 'text', icon: 'fa-eye' })
            : setPassword({ ...password, type: 'password', icon: 'fa-eye-slash' });
    };

    const handleClickShowconfirmPassword = () => {
        confirmPassword.type === "password"
          ? setConfirmPassword({ ...confirmPassword, type: "text", icon: "fa-eye" })
          : setConfirmPassword({ ...confirmPassword, type: "password", icon: "fa-eye-slash" });
      };

    // Yup schema to validate the form
    const validationSchema = Yup.object().shape({
        password: Yup.string().required().min(4),
        password_confirmation: Yup.string().required('Password is required')
            .oneOf([Yup.ref('password'), null], 'Passwords must match'),
    });

    // Formik hook to handle the form state
    const formik = useFormik({
        initialValues: {
            password: "",
            password_confirmation: "",
        },
        // Pass the Yup schema to validate the form
        validationSchema,
        // Handle form submission
        onSubmit: async (params, { resetForm }) => {
            const res = await authServices.resetPassword({ ...params, email: query.email, token: query.token });
            if (res.status) {
                if (userType == 'customer') {
                    push('/auth/customer/signin');
                } else {
                    push('/auth/healer/signin');
                }
                pageStateHandler('credentialSignIn');
                resetForm();
                toast.success(res.message, {
                    autoClose: 5000,
                });
            } else {
                toast.error(res.message, {
                    autoClose: 5000,
                });
                setValidationErrors(res.errors);
            }
        },
    });

    const { values, errors, touched, handleChange, handleSubmit } = formik;

    return (
        <Col sm={7} className="align-self-center">
            <div className="login-customer-card">
                <div className="card-header">
                    <h4>Reset Your Password</h4>
                    <p>Regain access to your account in just a few clicks - reset your password now!</p>
                </div>
                <div className="form-customer">
                    <Form onSubmit={handleSubmit}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text><i className="ri-lock-line"></i></InputGroup.Text>
                            <FormControl id="password" name="password" className='form-control' type={password.type} value={values.password} onChange={handleChange} placeholder="Password" />
                            <InputGroup.Text className="visible-icon" id="password-visible" onClick={handleClickShowPassword}><i className={`fa-solid ${password.icon}`}></i></InputGroup.Text>
                            <InputGroup>
                            <span className="w-100">{touched.password && errors.password ? <div className="text-danger h6">{errors.password}</div> : null}</span>
                                <ul>
                                    {
                                        validationErrors?.password?.map((err, i) => <li key={i} className="text-danger">{err}</li>)
                                    }
                                </ul>
                            </InputGroup>
                        </InputGroup>

                        <InputGroup>
                            <InputGroup.Text><i className="ri-lock-line"></i></InputGroup.Text>
                            <FormControl id="password_confirmation" name="password_confirmation" type={confirmPassword.type} value={values.password_confirmation} onChange={handleChange} placeholder="Confirm Password" />
                            <InputGroup.Text className="visible-icon" id="password-visible-1" onClick={handleClickShowconfirmPassword}><i className={`fa-solid ${confirmPassword.icon}`}></i></InputGroup.Text>
                            <span className="w-100">{touched.password_confirmation && errors.password_confirmation ? <div className="text-danger h6">{errors.password_confirmation}</div> : null}</span>
                        </InputGroup>
                        <div className="form-bottom">
                            <div className="backbtn ms-auto">
                                <Link href={`/auth/${userType}/forgot-password`} shallow={true} onClick={() => pageStateHandler('forgotPassword')}>Back <i className="ri-arrow-right-line"></i></Link>
                            </div>
                        </div>
                        <Button type="submit" className="theme-btn px-5" value="Reset Password">Change Password</Button>
                    </Form>
                </div>
                <div className="card-footer">
                    <p>If you are having problems recovering your password <Link href="#">Contact Us. &#xF2E7;</Link></p>
                </div>
            </div>
        </Col>
    );
}

export default ResetPasswordCard;
